import { brand, neutral, semantic, radius, shadow, typography } from "./tokens";

export const dashboardTheme = {
  token: {
    colorPrimary: brand.accent,
    colorInfo: semantic.info,
    colorSuccess: semantic.success,
    colorWarning: semantic.warning,
    colorError: semantic.danger,
    colorLink: brand.accent,

    colorTextBase: neutral[900],
    colorTextSecondary: neutral[500],
    colorTextTertiary: neutral[400],

    colorBgContainer: neutral[0],
    colorBgLayout: neutral[50],
    colorBorder: neutral[200],
    colorBorderSecondary: neutral[100],

    borderRadius: radius.md,
    borderRadiusLG: radius.md,
    borderRadiusSM: radius.base,

    fontFamily: typography.family,
    fontSize: typography.size.md,
    fontSizeHeading1: typography.size["3xl"],
    fontSizeHeading2: typography.size["2xl"],
    fontSizeHeading3: typography.size.xl,
    fontSizeHeading4: typography.size.lg,

    boxShadow: shadow.xs,
    boxShadowSecondary: shadow.sm,
    boxShadowTertiary: shadow.xs,

    motionDurationFast: "120ms",
    motionDurationMid: "180ms",
    motionDurationSlow: "240ms",
  },
  components: {
    Button: {
      borderRadius: radius.base,
      controlHeight: 36,
      fontWeight: 500,
      primaryShadow: "none",
      defaultShadow: "none",
    },
    Card: {
      borderRadiusLG: radius.md,
      boxShadowTertiary: shadow.xs,
      headerHeight: 52,
      headerHeightSM: 44,
      paddingLG: 24,
    },
    Table: {
      headerBg: neutral[50],
      headerColor: neutral[600],
      rowHoverBg: neutral[50],
      borderColor: neutral[100],
      headerBorderRadius: radius.base,
      cellPaddingBlock: 12,
      cellPaddingInline: 16,
    },
    Input: {
      borderRadius: radius.base,
      controlHeight: 36,
      activeBorderColor: brand.accent,
      hoverBorderColor: neutral[400],
    },
    Select: {
      borderRadius: radius.base,
      controlHeight: 36,
    },
    DatePicker: {
      borderRadius: radius.base,
      controlHeight: 36,
    },
    Modal: {
      borderRadiusLG: radius.md,
      titleFontSize: typography.size.lg,
      titleColor: neutral[900],
      colorBgMask: "rgba(15, 23, 42, 0.45)",
      boxShadow: shadow.md,
      headerBg: neutral[0],
    },
    Tabs: {
      colorText: neutral[600],
      colorPrimary: brand.primary,
      itemSelectedColor: brand.primary,
      itemHoverColor: neutral[900],
      titleFontSize: typography.size.md,
    },
    Menu: {
      colorItemBgSelected: "rgba(15, 42, 71, 0.08)",
      colorItemTextSelected: brand.primary,
      itemBorderRadius: radius.base,
      subMenuItemBorderRadius: radius.base,
      itemMarginInline: 6,
      itemPaddingInline: 12,
    },
    Tag: {
      borderRadiusSM: radius.sm,
      defaultBg: neutral[100],
      defaultColor: neutral[700],
    },
    Badge: {
      colorBgContainer: brand.accent,
    },
    Breadcrumb: {
      fontSize: typography.size.base,
      itemColor: neutral[500],
      lastItemColor: neutral[900],
      linkColor: neutral[500],
      separatorColor: neutral[300],
    },
    Form: {
      labelFontSize: typography.size.base,
      labelColor: neutral[700],
      labelRequiredMarkColor: semantic.danger,
      itemMarginBottom: 20,
    },
    Divider: {
      colorSplit: neutral[100],
    },
    Pagination: {
      borderRadius: radius.base,
    },
    Spin: { colorPrimary: brand.accent },
    Switch: { colorPrimary: brand.accent },
    Notification: { borderRadiusLG: radius.md },
    Message: { borderRadiusLG: radius.base },
  },
};
